import { render } from "./morePage.vue?vue&type=template&id=9f4bfe72&scoped=true"
import script from "./morePage.vue?vue&type=script&lang=js"
export * from "./morePage.vue?vue&type=script&lang=js"

import "./morePage.vue?vue&type=style&index=0&id=9f4bfe72&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9f4bfe72"

export default script